import React, { useEffect, useState } from 'react';
import { DropdownMenu, Text } from '@spark';
import LatencyCard from './LatencyCard';
import ThroughputCard from './ThroughputCard';
import RequestsCard from './RequestsCard';

const TIME_RANGE_OPTIONS = [
    { label: 'Last 1 hour', value: 'last-hour' },
    { label: 'Last 24 hours', value: 'last-24h' },
    { label: 'Last 7 days', value: 'last-7d' },
];

function useSecondsAgo(lastUpdated) {
    const [secondsAgo, setSecondsAgo] = useState(0);

    useEffect(() => {
        if (!lastUpdated) return undefined;
        const tick = () => setSecondsAgo(Math.round((Date.now() - lastUpdated.getTime()) / 1000));
        tick();
        const id = setInterval(tick, 5000);
        return () => clearInterval(id);
    }, [lastUpdated]);

    if (!lastUpdated) return null;
    if (secondsAgo < 60) return `Updated ${secondsAgo} seconds ago`;
    return `Updated ${Math.round(secondsAgo / 60)} minutes ago`;
}

/**
 * "Live Performance" section with time-range selector and the
 * three metric cards: Latency, Throughput, Requests.
 */
const LivePerformanceSection = ({
    latency,
    throughput,
    requests,
    lastUpdated,
    timeRange,
    onTimeRangeChange,
}) => {
    const updatedLabel = useSecondsAgo(lastUpdated);
    const activeOption = TIME_RANGE_OPTIONS.find((o) => o.value === timeRange) || TIME_RANGE_OPTIONS[0];

    return (
        <div className="live-perf-section">
            <div className="live-perf-section__header">
                <div className="live-perf-section__title-row">
                    <Text variant="body-semibold" as="h3">Live Performance</Text>
                    {updatedLabel && (
                        <span className="live-perf-section__updated">
                            <span className="live-perf-section__dot" aria-hidden="true" />
                            {updatedLabel}
                        </span>
                    )}
                </div>

                <DropdownMenu
                    size="medium"
                    label="Time range"
                    text={activeOption.label}
                    value={activeOption.value}
                    items={TIME_RANGE_OPTIONS.map((o) => ({ label: o.label }))}
                    onSelect={(_, idx) => onTimeRangeChange?.(TIME_RANGE_OPTIONS[idx].value)}
                />
            </div>

            <div className="live-perf-cards">
                <LatencyCard latency={latency} />
                <ThroughputCard throughput={throughput} />
                <RequestsCard requests={requests} />
            </div>
        </div>
    );
};

export default LivePerformanceSection;
